module.exports = __webpack_public_path__ + "img/Icon-1_cursor.c337b63d.svg";